import { render, staticRenderFns } from "./OrderShopGroup.vue?vue&type=template&id=406fa024&scoped=true"
import script from "./OrderShopGroup.vue?vue&type=script&lang=js"
export * from "./OrderShopGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406fa024",
  null
  
)

export default component.exports